exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".userList[data-v-555e4cf5]{display:flex;flex-direction:column;background:var(--secondary);grid-area:UL;padding:3px 6px 10px 16px;max-height:calc(100vh - 46px);overflow-y:scroll}.userList[data-v-555e4cf5]::-webkit-scrollbar{width:8px}.userList[data-v-555e4cf5]::-webkit-scrollbar-thumb{background:var(--tertiary);border-radius:4px}.userList[data-v-555e4cf5]::-webkit-scrollbar-track{background:var(--secondary)}.role[data-v-555e4cf5]{margin-top:20px;color:var(--grey);font-size:12px;font-weight:500;text-transform:uppercase}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-555e4cf5","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/User-List/index.vue
// module id = 92
// module chunks = 0